import { useSyncExternalStore } from 'react'

// A phone in landscape is wide but short — keying only off width would
// bounce landscape phones back into the desktop shell. Short edge +
// coarse pointer keeps narrow desktop windows out of the phone shell.
const MOBILE_QUERY =
  '(max-width: 767px), ((max-height: 500px) and (pointer: coarse))'
const LANDSCAPE_QUERY = '(orientation: landscape)'

const mqlCache = new Map<string, MediaQueryList>()

function mql(query: string): MediaQueryList {
  let m = mqlCache.get(query)
  if (!m) {
    m = window.matchMedia(query)
    mqlCache.set(query, m)
  }
  return m
}

function makeSubscribe(query: string) {
  return (onChange: () => void) => {
    const m = mql(query)
    m.addEventListener('change', onChange)
    return () => m.removeEventListener('change', onChange)
  }
}

const subscribeMobile = makeSubscribe(MOBILE_QUERY)
const subscribeLandscape = makeSubscribe(LANDSCAPE_QUERY)

/** True on phone-sized / touch-landscape viewports — switches App to the mobile shell. */
export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribeMobile, () => mql(MOBILE_QUERY).matches)
}

/** Live orientation — the mobile shell swaps bottom tabs (portrait) for a side rail (landscape). */
export function useIsLandscape(): boolean {
  return useSyncExternalStore(subscribeLandscape, () => mql(LANDSCAPE_QUERY).matches)
}
